var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeature3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 111 116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b3ddee;}.cls-2{fill:#0090b9;}.cls-3{fill:#fff;stroke:#0090b9;stroke-miterlimit:10;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.13,28.29v-13A43.17,43.17,0,0,0,22.68,27.37l9.2,9.2a30.13,30.13,0,0,1,19.25-8.28Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96,61.38H83a30.05,30.05,0,0,1-8.19,18.08l9.2,9.2A43.24,43.24,0,0,0,96,61.38Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.09,58.12h13a43.21,43.21,0,0,0-11-28.41l-9.22,9.23a30.13,30.13,0,0,1,7.21,19.18Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.4,81.69a30.08,30.08,0,0,1-18,7.18v13a43.2,43.2,0,0,0,27.24-11L72.4,81.69Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.13,88.87a30.08,30.08,0,0,1-18-7.18l-9.23,9.23a43.23,43.23,0,0,0,27.24,11v-13Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.65,38.94l-9.23-9.23a43.21,43.21,0,0,0-11,28.41h13a30.09,30.09,0,0,1,7.22-19.18Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.84,27.37A43.17,43.17,0,0,0,54.39,15.26v13a30.13,30.13,0,0,1,19.25,8.28l9.2-9.2Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.5,61.38A43.24,43.24,0,0,0,21.55,88.66l9.2-9.2a30.11,30.11,0,0,1-8.19-18.08Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 45.44,
    cy: 58.23,
    r: 14.68
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 60.12,
    cy: 58.23,
    r: 14.68
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature3);
export default __webpack_public_path__ + "static/media/feature3.956b56e5f7dbc93992ddd75bbc55fff1.svg";
export { ForwardRef as ReactComponent };